import * as apiConstants from '../apiConstants';

import ApiOperation from '../ApiOperation';


class ApiRequest extends ApiOperation {

    /**
     * @type {{}}
     * @private
     */
    dispatches = {};

    /**
     * @type {string|null}
     * @private
     */
    method = null;

    /**
     * @type {string|null}
     * @private
     */
    path = null;

    /**
     * @type {{}}
     * @private
     */
    pathVariables = {};

    /**
     * @type {{}}
     * @private
     */
    queryParameters = {};

    /**
     * Final URL of the request
     * @type {null|string}
     * @private
     */
    url = null;


    /**
     * @param path {string} Path of the request
     * @param method {string} HTTP method to use
     */
    constructor(path, method = apiConstants.HTTP_METHOD_GET) {

        super();

        this.path = path;
        this.method = method;

        this.dispatches[apiConstants.REQUEST_FAILURE] = [];
        this.dispatches[apiConstants.REQUEST_INIT] = [];
        this.dispatches[apiConstants.REQUEST_SUCCESS] = [];
    }


    /**
     * @param type {number|string} Any allowed dispatch type
     * @param dispatchCallback {function} Callback
     * @returns {ApiRequest}
     */
    addDispatch(type, dispatchCallback) {

        this.getDispatchesForType(type).push(dispatchCallback);
    }


    getDispatches(type) {

        return this.getDispatchesForType(type);
    }



    /**
     * @param type {number|string} Type to get dispatches for
     * @returns {[]} List of registered dispatches
     */
    getDispatchesForType = type => {

        if (typeof type === 'number') {
            type = type.toString(10);
        }

        if (this.dispatches[type] === undefined) {
            this.dispatches[type] = [];
        }

        return this.dispatches[type];
    };


    /**
     * @returns {string} HTTP request method
     */
    getMethod() {

        return this.method;
    }


    /**
     * @param method {string} HTTP request method
     */
    setMethod(method) {

        this.method = method;
    }


    /**
     * @return {string} Request path
     */
    getPath() {

        return this.path;
    }


    /**
     * @param path {string} Request path
     */
    setPath(path) {

        this.path = path;
    }


    getPathVariable(name, defaultValue) {

        if (this.pathVariables.hasOwnProperty(name)) {

            return this.pathVariables[name];
        }

        return defaultValue !== undefined ? defaultValue : null;
    }


    /**
     * @param name {string} Path variable name
     * @param value {string|number} Path variable value
     */
    setPathVariable(name, value) {

        this.pathVariables[name] = value;
    }


    getPathVariables() {

        return this.pathVariables;
    }


    /**
     * @param pathVariables {object} Key/value path variables (key->name, value->value)
     */
    setPathVariables(pathVariables) {

        this.pathVariables = pathVariables;
    }


    /**
     * @param name {string} Query parameter name to get value for
     * @param defaultValue {*} Value returned in case the name doesn't exist
     * @returns {*} Value of default value
     */
    getQueryParameter(name, defaultValue = null) {

        if (this.queryParameters.hasOwnProperty(name)) {

            return this.queryParameters[name];
        }

        return defaultValue;
    }


    /**
     * @param name {string} Query parameter name
     * @param value {string|number} Query parameter value
     */
    setQueryParameter(name, value) {

        this.queryParameters[name] = value;
    }


    /**
     * @returns {object|{}} All query parameters
     */
    getQueryParameters() {

        return this.queryParameters;
    }


    /**
     * @returns {string|null} Fully constructed URL
     */
    getUrl() {

        return this.url;
    }


    /**
     * @param url {string} Fully constructed url
     */
    setUrl(url) {

        this.url = url;
    }


    /**
     * @return {object} Loggable output
     */
    toLog() {

        return {
            method: this.getMethod(),
            url: this.getUrl(),
            ...super.toLog()
        };
    }
}


export default ApiRequest;
